/* Keeps one free gift in the cart while a promo product is in it, tells the
   shopper in the UpCart drawer when a code they typed loses to the promo, and
   keeps the gift line and the upsells in the drawer consistent with the gift.
   With no promo running (gift null, no products) it only takes leftover free
   gifts out of the cart, so nobody pays for a gift after the promo ends.
   Config comes from window.cPromoGift, set in layout/theme.liquid. */
(function () {
  var cfg = window.cPromoGift;
  if (!cfg || !cfg.products) return;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var nativeFetch = window.fetch.bind(window);
  var busy = false;
  var queued = false;
  var typedKey = 'c-promo-typed-codes';

  /* Codes the shopper typed in the drawer this visit. A code saved from a
     /discount/ link rides along silently, so it never gets a note. */
  function typedCodes() {
    try {
      return JSON.parse(sessionStorage.getItem(typedKey)) || [];
    } catch (e) {
      return [];
    }
  }

  function rememberTyped(event) {
    var host = document.querySelector('#upCart');
    if (!host || event.composedPath().indexOf(host) === -1) return;
    if (event.type === 'keydown' && event.key !== 'Enter') return;
    if (event.type === 'click' && !event.composedPath().some(function (el) { return el.tagName === 'BUTTON'; })) return;
    var input = host.shadowRoot && host.shadowRoot.querySelector('input[placeholder*="iscount"]');
    var code = input && input.value.trim().toUpperCase();
    if (!code) return;
    var codes = typedCodes();
    if (codes.indexOf(code) === -1) codes.push(code);
    try {
      sessionStorage.setItem(typedKey, JSON.stringify(codes));
    } catch (e) {}
  }

  document.addEventListener('click', rememberTyped, true);
  document.addEventListener('keydown', rememberTyped, true);

  function post(path, body) {
    return nativeFetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
  }

  function refresh() {
    if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
    document.dispatchEvent(new CustomEvent('c-promo-gift:updated'));
    if (/\/cart\/?$/.test(window.location.pathname)) window.location.reload();
  }

  /* UpCart drops a code that can't combine without saying why. */
  function showCodeNote(codes) {
    var host = document.querySelector('#upCart');
    var rootNode = host && host.shadowRoot;
    if (!rootNode) return;
    var note = rootNode.querySelector('.c-promo-code-note');
    if (!codes.length) {
      if (note) note.remove();
      return;
    }
    var input = rootNode.querySelector('input[placeholder*="iscount"]');
    if (!input) return;
    if (!note) {
      note = document.createElement('p');
      note.className = 'c-promo-code-note';
      note.setAttribute('role', 'status');
      note.style.cssText = 'margin:6px 16px 0;font-size:13px;line-height:1.35;color:#b3261e;';
    }
    note.textContent = codes.join(', ') + " wasn't applied. It can't be combined with the current offer.";
    var row = input.closest('form') || input.parentElement.parentElement || input.parentElement;
    if (note.previousElementSibling !== row) row.insertAdjacentElement('afterend', note);
  }

  function noteRejectedCodes(cart, hasPromo) {
    var typed = typedCodes();
    var rejected = hasPromo
      ? (cart.discount_codes || [])
          .filter(function (d) { return !d.applicable && typed.indexOf(d.code.toUpperCase()) !== -1; })
          .map(function (d) { return d.code; })
      : [];
    [0, 700, 1800].forEach(function (delay) {
      setTimeout(function () { showCodeNote(rejected); }, delay);
    });
  }

  async function sync() {
    if (busy) {
      queued = true;
      return;
    }
    busy = true;
    try {
      var res = await nativeFetch(root + 'cart.js', { headers: { Accept: 'application/json' } });
      var cart = await res.json();
      var hasPromo = cart.items.some(function (item) {
        return cfg.products.indexOf(item.product_id) !== -1;
      });
      var gift = cart.items.find(function (item) {
        return item.variant_id === cfg.gift;
      });
      /* A gift product the theme no longer gives (a cart from before the gift
         changed) leaves the cart, so nobody ends up with two free gifts. */
      var stale = cart.items.filter(function (item) {
        return item.variant_id !== cfg.gift && /-free-gift$/.test(item.handle);
      });
      var changed = true;
      if (stale.length) {
        var updates = {};
        stale.forEach(function (item) { updates[item.key] = 0; });
        await post('cart/update.js', { updates: updates });
        queued = true;
      } else if (hasPromo && !gift) {
        await post('cart/add.js', { items: [{ id: cfg.gift, quantity: 1 }] });
      } else if (!hasPromo && gift) {
        await post('cart/change.js', { id: gift.key, quantity: 0 });
      } else if (gift && gift.quantity > 1) {
        await post('cart/change.js', { id: gift.key, quantity: 1 });
      } else {
        changed = false;
      }
      if (changed) refresh();
      noteRejectedCodes(cart, hasPromo);
    } catch (e) {
      /* a failed sync leaves the cart as the shopper built it */
    } finally {
      busy = false;
      if (queued) {
        queued = false;
        sync();
      }
    }
  }

  /* In the drawer the free gift line doesn't link to its product page or
     offer a quantity stepper, and the paid version of the gift leaves the
     upsells while the gift is in. */
  function productLink(handle) {
    return 'a[href^="/products/' + handle + '"], a[href*="/products/' + handle + '?"]';
  }

  function tidyDrawer(rootNode) {
    if (cfg.giftHandle) {
      rootNode.querySelectorAll('.upcart-product-item ' + productLink(cfg.giftHandle)).forEach(function (link) {
        link.removeAttribute('href');
        link.setAttribute('data-c-gift', '');
        link.style.cursor = 'default';
      });
      rootNode.querySelectorAll('.upcart-product-item').forEach(function (item) {
        if (!item.querySelector('[data-c-gift]')) return;
        var plus = item.querySelector('.upcart-product-quantity-plus');
        var stepper = plus && (plus.closest('[class*="stepper"]') || plus.parentElement);
        if (stepper) stepper.style.display = 'none';
      });
    }
    if (!cfg.upsellHandle) return;
    var hasGift = !!rootNode.querySelector('.upcart-product-item [data-c-gift]');
    rootNode.querySelectorAll('.upcart-upsells-module').forEach(function (module) {
      var slides = Array.prototype.slice.call(module.querySelectorAll('li'));
      var paid = slides.filter(function (li) { return li.querySelector(productLink(cfg.upsellHandle)); });
      var hideAll = hasGift && paid.length && paid.length === slides.length;
      module.style.display = hideAll ? 'none' : '';
      paid.forEach(function (li) { li.style.display = hasGift && !hideAll ? 'none' : ''; });
    });
  }

  function watchDrawer() {
    var host = document.querySelector('#upCart');
    if (!host || !host.shadowRoot) return false;
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        tidyDrawer(host.shadowRoot);
      });
    }).observe(host.shadowRoot, { childList: true, subtree: true });
    tidyDrawer(host.shadowRoot);
    return true;
  }

  /* UpCart mounts its shadow root after load. */
  var drawerTries = 0;
  var drawerTimer = setInterval(function () {
    if (watchDrawer() || ++drawerTries > 40) clearInterval(drawerTimer);
  }, 500);

  function isCartWrite(url) {
    return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url || '');
  }

  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var request = nativeFetch(input, init);
    if (isCartWrite(url)) request.then(sync, function () {});
    return request;
  };

  var nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isCartWrite(String(url))) this.addEventListener('load', sync);
    return nativeOpen.apply(this, arguments);
  };

  sync();
})();
